// Shared client-side export helpers (no external deps).
export function downloadCsv(filename, rows) {
  const csv = rows
    .map((r) => r.map((c) => {
      const s = String(c ?? "");
      return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
    }).join(","))
    .join("\n");
  const url = URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
}

export function printReport(title, bodyHtml) {
  const w = window.open("", "_blank");
  if (!w) return;
  w.document.write(`<html><head><title>${title}</title><style>
    body{font-family:Arial,Helvetica,sans-serif;color:#0f172a;padding:36px;max-width:900px;margin:auto}
    h1{font-size:24px;margin:0 0 2px} h2{font-size:15px;margin:24px 0 8px;border-bottom:2px solid #10b981;padding-bottom:4px}
    .muted{color:#64748b;font-size:12px} table{width:100%;border-collapse:collapse;font-size:12px;margin-top:6px}
    th,td{text-align:left;padding:6px 8px;border-bottom:1px solid #eee} th{color:#334155}
    .kpis{display:flex;flex-wrap:wrap;gap:18px;margin-top:8px}
    .kpi{min-width:150px} .kpi b{display:block;font-size:22px;color:#0f172a} .kpi span{font-size:11px;color:#64748b}
    .hero{background:#ecfdf5;border:1px solid #a7f3d0;border-radius:10px;padding:14px 18px;margin-top:10px}
  </style></head><body>${bodyHtml}<script>window.onload=function(){setTimeout(function(){window.print();},250);};</script></body></html>`);
  w.document.close();
}
